var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map-wrapper" },
    [
      _vm.locations.length
        ? _c(
            "GmapMap",
            {
              ref: "gmap",
              attrs: {
                center: _vm.locations[0].coordinates,
                zoom: 12,
                "map-type-id": "roadmap",
              },
            },
            _vm._l(_vm.locations, function (location, index) {
              return _c(
                "GmapMarker",
                {
                  key: location.id,
                  attrs: {
                    position: location.coordinates,
                    clickable: true,
                    draggable: false,
                    visible: true,
                    title: "location.title",
                    icon: { url: _vm.pinIconForLocationAtIndex(index) },
                  },
                  on: {
                    click: function ($event) {
                      return _vm.didSelectLocationAtIndex(index)
                    },
                  },
                },
                [
                  _c(
                    "GmapInfoWindow",
                    {
                      attrs: {
                        opened: index === _vm.selectedLocationIndex,
                        position: location.coordinates,
                      },
                    },
                    [
                      _c("div", { staticClass: "map-info" }, [
                        _c("h3", [_vm._v(_vm._s(location.title))]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: { innerHTML: _vm._s(location.info_html) },
                        }),
                      ]),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/GoogleMap.vue